export default __webpack_public_path__ + "static/media/x-circle.49eafd0c.svg";